import type { GameLogicContent, GameLogicStatic, SlideTypeEvent } from "@types"
import defaultGameData from "../defaultGameData"

// Templates Strings
// Stats {$age}, {$choices}, {$duration}
// Meters {$education}, {$relationship}, {$health}\

const GAMEDATA: GameLogicStatic = {
  rules: {
    multipler: 1,
    age: { lt: 24 }, //reduced ending age temporarily until more content, was 24 TODO
    agency: { gt: -1000, lt: 1000 },
    education: { gt: -1000, lt: 1000 },
    relationship: { gt: -1000, lt: 1000 },
    health: { gt: -1000, lt: 1000 },
    mentalHealth: { gt: -1000, lt: 1000 },
    physicalHealth: { gt: -1000, lt: 1000 },
  },
  start: {
    turn: 0,
    duration: 0,
    age: 4,
    agency: 5,
    education: 50,
    relationship: 5,
    health: 5,
    mentalHealth: 50,
    physicalHealth: 50,
    history: [],
    slide: {
      title: { en: "Welcome to My Choices" },
      description: { en: "Press Continue" },
      image: "/images/start_slide-1024.jpg",
      imageSrcSet: "/images/start_slide-1024.jpg 1024w",
      imageAlt: "slide alt text",
      type: "choice",
      selections: [
        {
          title: { en: "Continue" },
          icon: "positive",
        },
      ],
    },
    tags: [],
    effects: {
      age: 1,
    },
  },
  content: defaultGameData as GameLogicContent,
}

export default GAMEDATA
